import ChatActions from "../../actions/ChatActions";
import alt from "../../alt/ChatAlt";

export class AuthStore {
    constructor() {
        this.bindActions(ChatActions);
        this.bindListeners({
            onAuthFail: [ChatActions.authFail, ChatActions.resetAuth],
            onAuthSuccess: [ChatActions.askQuestionSuccess, ChatActions.authSuccess],
        });

        this.state = {
            isLoading: true,
            isLoggedIn: false,
        };
    }

    onAuthFail() {
        this.setState({ isLoading: false, isLoggedIn: false });
    }

    onAuthSuccess() {
        this.setState({ isLoading: false, isLoggedIn: true });
    }

    onLogoutSuccess() {
        this.setState({ isLoading: false, isLoggedIn: false });
    }

    onUpdateContactSuccess() {
        this.setState({ isLoading: false });
    }
}

export default alt.createStore(AuthStore, "AuthStore");
